module.exports = __webpack_public_path__ + "img/stampW.a677d32d.svg";